import { ref } from 'vue'
import { defineStore } from 'pinia'
import userApi from '@/api/userApi'

export const useSettingsStore = defineStore('settingsStore', () => {
  const settings = ref<UserSetting[]>([])

  const load = () => {
    userApi.settings().then((response) => {
      settings.value = response.data
    })
  }

  const getString = (key: SettingKeyEnum): string | undefined => {
    return settings.value.find((setting) => setting.key === key)?.stringValue ?? undefined
  }

  const getBool = (key: SettingKeyEnum): boolean | undefined => {
    return settings.value.find((setting) => setting.key === key)?.boolValue ?? undefined
  }

  return { settings, load, getString, getBool }
})
